import { fetchWrapper } from "@/helpers";

const ruta = process.env.VUE_APP_ROOT_API;

export default class ParametrosService {
  async getAll() {
    return await fetchWrapper.get(`${ruta}/parametros`);
  }

  async updateEstado(id, nuevoEstado) {
    return await fetchWrapper.put(`${ruta}/parametros/${id}/estado`, {
      estado: nuevoEstado,
    });
  }
}
